import { 
	makeSlave,initColorSelect, doAjax, updateTableValue, initStitchesBackgroundColorListeners, initRedPointLogic, fakeSelected } from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'

var masterselect = 0
var mastercolor = 0

const initInteriorYZ4Customizing = () => {
	initColorSelect()
	loadAlreadyCustomizedOptions()
	//const isLeatherPackage = aeo['configuration']['YS1'] === true
	//const setYS1 = aeo['configuration']['YS1'] === true
	//const setYZ1 = (aeo['configuration']['YZ1'] === true || aeo['configuration']['YZ1_Q7Q8'] === true)
	const setYZ4 = true

	//const isStitchingPackage = aeo['configuration']['YVJ'] === true 


	if (setYZ4) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			doorArmRest:'stitchDoorArmRest',
			bottomCenterConsole:'stitchbottomCenterConsole',
			instrumentPanelCover:'stitchInstrumentPanelCover',
			doorRail:'stitchDoorRail',
			doorPanelBelow:'stitchDoorPanelBelow',
			instrumentPanelCoverBelow: '',
			rockerPanel: '',
		}

		for (const key in interiorComponents) {
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,setImage)
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId)
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, setImage)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId,setImage)
			}
		}
	} 
}

/**Returns the DOT ID for the component on params */
function getDotIdWithComponent(component) {
	switch (component) {
		case 'doorArmRest': return 'dot_tuerarmauflage'
		case 'stitchDoorArmRest': return 'dot_tuerarmauflage-kontrastnaht'
		case 'bottomCenterConsole': return 'dot_mittelkonsole-unten'
		case 'stitchbottomCenterConsole': return 'dot_mittelkonsole-unten-kontrastnaht'
		case 'instrumentPanelCover': return 'dot_instru-abdeck'
		case 'stitchInstrumentPanelCover': return 'dot_naht-instru-abdeck'
		case 'doorRail': return 'dot_tuerbrustung'
		case 'stitchDoorRail': return 'dot_naht-tierbruestung'
		case 'doorPanelBelow': return 'dot_doorPanelBelow'
		case 'stitchDoorPanelBelow': return 'dot_stitchDoorPanelBelow'
		case 'instrumentPanelCoverBelow': return 'dot_instrumentPanelCoverBelow'
		case 'rockerPanel': return 'dot_rockerPanel'
		default: break;
	}
}

/** Condition for makeSlave function to work */
function areMasterAndSlaveDefault(masterDotID, slaveDotID){
	let res = false;
	const masterTileSelectedValue = document.querySelector('#' + masterDotID + ' .color.selected input')?.value
	const slaveTileSelectedValue = document.querySelector('#' + slaveDotID + ' .color.selected input')?.value
	if (masterTileSelectedValue != null && masterTileSelectedValue == aeo['default_color'] && slaveTileSelectedValue == aeo['default_color']){
		res = true;
	}
	return res;
}

function setStitchColorPrimSec(component, colorCode, master=false) {
	setImage(component, colorCode, master) 
	fakeSelected(getDotIdWithComponent(component), colorCode)
}

function setImage(component, colorCode, master=false) {
	
	// master slave 
	if(component == 'doorRail' && !master && (document.querySelector('#doorRail td[color-code]').getAttribute('color-code') == 8)) {
		setStitchColorPrimSec('instrumentPanelCover', colorCode, master=true)
		mastercolor = colorCode
		mastercolor
		masterselect++
	}
	
	if(component == 'instrumentPanelCover' && !master && (document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code') == 8)) {
		setStitchColorPrimSec('doorRail', colorCode, master=true)
		mastercolor = colorCode
		masterselect++
	}
	
	if(component == 'stitchDoorRail' && !master  && ((document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code') == 8 ) || (document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code') == mastercolor ))) {
		setStitchColorPrimSec('stitchInstrumentPanelCover', colorCode, master=true)
		masterselect++
	}

	if(component == 'stitchInstrumentPanelCover' && !master  && ((document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code') == 8)  || (document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code') == mastercolor ))) {
		setStitchColorPrimSec('stitchDoorRail', colorCode, master=true)
		masterselect++
	}

	// interconnection doorPanelBelow + rockerPanel
	if(component == 'doorPanelBelow') {
		setStitchColorPrimSec('rockerPanel', colorCode)
	}
	
	// set leather color to stich 
	if(component == 'instrumentPanelCover' 
		&& (document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code') == document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
		|| document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code') == 199 )) {
			setStitchColorPrimSec('stitchInstrumentPanelCover', colorCode)
	}

	if(component == 'doorPanelBelow' 
		&& (document.querySelector('#doorPanelBelow td[color-code]').getAttribute('color-code') == document.querySelector('#stitchDoorPanelBelow td[color-code]').getAttribute('color-code')
		|| document.querySelector('#stitchDoorPanelBelow td[color-code]').getAttribute('color-code') == 199 )) {
			setStitchColorPrimSec('stitchDoorPanelBelow', colorCode)
	}

	if(component == 'bottomCenterConsole' 
		&& (document.querySelector('#bottomCenterConsole td[color-code]').getAttribute('color-code') == document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
		|| document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code') == 199 )) {
			setStitchColorPrimSec('stitchbottomCenterConsole', colorCode)
	}

	if(component == 'doorRail' 
		&& (document.querySelector('#doorRail td[color-code]').getAttribute('color-code') == document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code')
		|| document.querySelector('#stitchDoorRail td[color-code]').getAttribute('color-code') == 199 )) {
			setStitchColorPrimSec('stitchDoorRail', colorCode)
	}

	if(component == 'doorArmRest' 
		&& (document.querySelector('#doorArmRest td[color-code]').getAttribute('color-code') == document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
		|| document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code') == 199 )) {
			setStitchColorPrimSec('stitchDoorArmRest', colorCode)
	}
	
	
	//if(component == centerArmrest && centerArmrest)
	let imageSourceFront;
	let imageSourceBack;
	//let isStitchingPackage = aeo['configuration']['YVJ'] == true 
	//let isHourMarkSteeringWheel = aeo['configuration']['YVN'] == true
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value
	const seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
	const modelcategory = document.querySelector("input[name=modelcategory]").value
	//if (isStitchingPackage){
	//	imageSourceFront = aeo['images'][isHourMarkSteeringWheel ? 'twelve_mark_interior_stitch_front' : 'interior_stitch_front'][colorCode]
	//	imageSourceBack = aeo['images']['interior_stitch_back'][colorCode]
	//}else{
		imageSourceFront = aeo['paths']['car_frontseat_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][component]
		imageSourceBack = aeo['paths']['car_backseat_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][component]
	//}
	
	//replace image on front and back
	replaceImage(imageSourceFront, component+'Color', 'car_frontseat')
	if ( component != 'instrumentPanelCoverBelow' 
		&& component != 'instrumentPanelCover'
		&& component != 'stitchInstrumentPanelCover') {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
	}

	/*
	switch(modelcategory) {
		case 'e-tron_gt': 
		if (component != 'topCenterConsole') {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
		break; 
		default: 
		if (component == 'doorTrimInsert') {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
	}*/
	

	

	updateTableValue(component, colorCode,'interior-components')
	doAjax({
		'interior_component' : component,
		'color' : colorCode,
		'src': imageSourceFront
	})
}

export { initInteriorYZ4Customizing };